import { i18n } from "./index.js";

export default i18n;